export default __webpack_public_path__ + "static/media/icon_fitness_active.a86cafba.png";